import apiUrl from "../config/apiUrl";
import fetchUrl from "../utils/fetchUrl";

export const GET_NOTIFICATION = async () => {
  return await fetchUrl({
    method: "GET",
    url: `${apiUrl}notification/getNotification?page=${0}&size=${100}`,
  });
};
export const SEEN_NOTIFICATION = async (id: string) => {
  return await fetchUrl({
    url: `${apiUrl}notification/seenNotification?notifId=${id}`,
    method: "GET",
  });
};
export const NOTIFICATION_REGISTER_TOKEN = async () => {
  try {
    return await fetchUrl({
      url: `${apiUrl}notification/registerToken?token=${localStorage.getItem(
        "najva-token"
      )}`,
      method: "GET",
    });
  } catch (error) {
    console.log(error);
  }
};
